// @flow

import React from "react";

import { LinkedFieldValues } from "./styles";
import { FieldValue } from "./Values/styles";
import LinkedRoom from "src/components/messages/Chat/Notification/LinkedRoom";

import type { RoomId } from "src/types";

type Props = {
  oldValue: Array<RoomId>,
  disableTitleHyperlink: boolean,
};

const OldConversationValues = ({ oldValue, disableTitleHyperlink }: Props) => {
  return (
    <FieldValue old>
      <LinkedFieldValues>
        {oldValue.map((val, id) => (
          <LinkedRoom
            id={`${val}`}
            key={id}
            disableTitleHyperlink={disableTitleHyperlink}
          />
        ))}
      </LinkedFieldValues>
    </FieldValue>
  );
};

export default OldConversationValues;
